import { createContext } from 'react';

const WizardContext = createContext(undefined);

export default WizardContext;
